module.exports = __webpack_public_path__ + "media/images/icon-notices-867eb2f88009daafebc6e84dfb3f96d2.svg";